// Generated file : do not modify
export enum AdminAttribLevels
{
  NONE = 0,
  HIDDEN,
  SUPERADMIN,
  ADMIN,
  APPLI
};

import { ListChoix } from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Attributs de classe
export default class AdminAttrib  {
  // Identifiant unique
  public id: number;
  // SQL
  public sqlAtt: boolean;
  // Table
  public tableName: string;
  // Attribut
  public value: string;
  // Type de ressource
  public level: AdminAttribLevels;
  // Libellé
  public text: string;
  // Type
  public type: string;
  // 
  public choix: ListChoix[];
  // Colonne dans la table, 0 si non affiché
  public tableCol: number;
  // largeur en px
  public width: string;
  // Lecture seule
  public readOnly: boolean;
  // Affiché dans l'éditeur
  public displayed: boolean;
  // PlaceHolder
  public placeHolder: string;
  // Valeur min
  public min: number | null;
  // Valeur max
  public max: number | null;
  // Validateur
  public live: string;
  // Validateur sur perte focus
  public focus: string;
  // Recherche full text
  public isSearchable: boolean;
  // Filtrable
  public isFilterable: boolean;
  // Nom pour le publi-postage
  public publiName: string;
  // classe étrangère
  public foreignClass: string;
  // Nom de la classe étrangère
  public foreignTableName: string;
  // Nom de la classe parente
  public sqlClass: string;
  // Nom attribut dans la classe parente
  public sqlKey: string;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.sqlAtt = false;
    this.tableName = '';
    this.value = '';
    this.level = AdminAttribLevels.NONE;
    this.text = '';
    this.type = '';
    this.choix = [];
    this.tableCol = 0;
    this.width = '';
    this.readOnly = false;
    this.displayed = false;
    this.placeHolder = '';
    this.min = null;
    this.max = null;
    this.live = '';
    this.focus = '';
    this.isSearchable = false;
    this.isFilterable = false;
    this.publiName = '';
    this.foreignClass = '';
    this.foreignTableName = '';
    this.sqlClass = '';
    this.sqlKey = '';
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: AdminAttrib): AdminAttrib {
    const newAdminAttrib: AdminAttrib = new AdminAttrib();
    newAdminAttrib.id = obj.id;
    newAdminAttrib.sqlAtt = obj.sqlAtt;
    newAdminAttrib.tableName = obj.tableName;
    newAdminAttrib.value = obj.value;
    newAdminAttrib.level = obj.level;
    newAdminAttrib.text = obj.text;
    newAdminAttrib.type = obj.type;
    newAdminAttrib.choix = JSON.parse(JSON.stringify(obj.choix));
    newAdminAttrib.tableCol = obj.tableCol;
    newAdminAttrib.width = obj.width;
    newAdminAttrib.readOnly = obj.readOnly;
    newAdminAttrib.displayed = obj.displayed;
    newAdminAttrib.placeHolder = obj.placeHolder;
    newAdminAttrib.min = obj.min;
    newAdminAttrib.max = obj.max;
    newAdminAttrib.live = obj.live;
    newAdminAttrib.focus = obj.focus;
    newAdminAttrib.isSearchable = obj.isSearchable;
    newAdminAttrib.isFilterable = obj.isFilterable;
    newAdminAttrib.publiName = obj.publiName;
    newAdminAttrib.foreignClass = obj.foreignClass;
    newAdminAttrib.foreignTableName = obj.foreignTableName;
    newAdminAttrib.sqlClass = obj.sqlClass;
    newAdminAttrib.sqlKey = obj.sqlKey;
    newAdminAttrib.canUpdate = obj.canUpdate;
    newAdminAttrib.canDelete = obj.canDelete;
    newAdminAttrib.display = obj.display;
    newAdminAttrib.notifDefType = obj.notifDefType;
    return newAdminAttrib;
  }

  public toJsonAdminAttrib (): string {
    const json = {
      sqlAtt: this.sqlAtt,
      tableName: this.tableName,
      value: this.value,
      level: this.level,
      text: this.text,
      type: this.type,
      choix: this.choix,
      tableCol: this.tableCol,
      width: this.width,
      readOnly: this.readOnly,
      displayed: this.displayed,
      placeHolder: this.placeHolder,
      min: this.min,
      max: this.max,
      live: this.live,
      focus: this.focus,
      isSearchable: this.isSearchable,
      isFilterable: this.isFilterable,
      publiName: this.publiName,
      foreignClass: this.foreignClass,
      foreignTableName: this.foreignTableName,
      sqlClass: this.sqlClass,
      sqlKey: this.sqlKey,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromAdminAttrib (obj: AdminAttrib): void {
    this.id = obj.id;
    this.sqlAtt = obj.sqlAtt;
    this.tableName = obj.tableName;
    this.value = obj.value;
    this.level = obj.level;
    this.text = obj.text;
    this.type = obj.type;
    this.choix = obj.choix;
    this.tableCol = obj.tableCol;
    this.width = obj.width;
    this.readOnly = obj.readOnly;
    this.displayed = obj.displayed;
    this.placeHolder = obj.placeHolder;
    this.min = obj.min;
    this.max = obj.max;
    this.live = obj.live;
    this.focus = obj.focus;
    this.isSearchable = obj.isSearchable;
    this.isFilterable = obj.isFilterable;
    this.publiName = obj.publiName;
    this.foreignClass = obj.foreignClass;
    this.foreignTableName = obj.foreignTableName;
    this.sqlClass = obj.sqlClass;
    this.sqlKey = obj.sqlKey;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareAdminAttrib (value: AdminAttrib): boolean {
    return (this.toJsonAdminAttrib() == value.toJsonAdminAttrib());
  }

  public cloneAdminAttrib (): AdminAttrib {
    return AdminAttrib.fromJson(this);
  }

  // eslint-disable-next-line
  public static getDate(adminAttribs: AdminAttrib[]) {
  }
}
